import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';

import { validateForm } from '../Common/formValidator';

import { API } from '../../ws/constants';

import './style.css';
import SegmentationArgument from './SegmentationArgument';

var moment = require('moment');

class AddEditSegmentation extends Component {
    date = moment();
    state = {
        listId:this.props.id
        ,openModal: false
        ,returnTitle: "Erro"
        ,returnText: "Ocorreu algum erro"
        ,editable: (this.props.isAdmin || this.props.loginData.profile.Clients.permission === 1)
        ,listData:null
        ,fetchArguments: []
        ,fetchFields: []
        ,fetchConditions: []
        ,segmentationResults: []
        ,loading:false
        ,listName:'Nova Lista'
        ,listDescription:''
        ,listResults:0
        ,isActive:"1"
        ,groups: []
        ,filterText: ''
    };

    componentDidMount() {
        const { listId } = this.state;
        const newState = {};
        const fetches = [
            fetch(API + "getsegmentationfields&table=segmentation")
            , fetch(API + "getsegmentationconditions")
        ];
        
        if(listId !== "New"){
            fetches.push(fetch(API + "getsegmentationlist&getbyid=" + listId));
            fetches.push(fetch(API + "getsegmentationarguments&listid=" + listId));
        }

        Promise.all(fetches)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then(result => {
            if(listId !== "New"){
                const listData = result[2].data;
                const fetchArguments = [];
                const groups = [];

                for(let i=0, n=result[3].data.length;i<n;i++){
                    const index = Math.max(1, ...fetchArguments.map(x => x.index+1));
                    const thisArgument = result[3].data[i];
                    const groupId = parseInt(thisArgument.GroupId);
                    const thisGroup = groups.find(x => x.id === groupId);
    
                    if(groupId){
                        if(thisGroup){
                            thisGroup.indexesInGroup = [...thisGroup.indexesInGroup, index];
                        }else{
                            const newGroup = {
                                id: groupId,
                                indexesInGroup: [index]
                            };

                            groups.push(newGroup);
                        }
                    }
    
                    fetchArguments.push({
                        index,
                        groupId,
                        text: thisArgument.ArgumentText,
                        field: {
                            id: `field_${index}`,
                            value: thisArgument.Field,
                            type: thisArgument.FieldType
                        },
                        condition: {
                            id: `condition_${index}`,
                            value: thisArgument.ConditionId,
                        },
                        finalArgument: thisArgument.Argument
                    });
    
                }
                this.handleRefreshResults();
                
                newState.listData = listData;
                newState.fetchArguments = fetchArguments;
                newState.groups = groups;
                newState.listName = listData.Name || this.state.name;
                newState.listDescription = listData.Description || this.state.description;
                newState.isActive = listData.IsActive;
            }
                
            newState.fetchFields = result[0].data;
            newState.fetchConditions = result[1].data;
            
            this.setState(newState, this.updateFilterText)
        });
    }

    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0" });

    handleSave = () => {
        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: false, showErrorMessage: true, dumbValidations: false })){
            fetch(API + "savesegmentationlist", {
                method: 'POST'
                ,headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
                ,body: JSON.stringify({
                    listid:this.state.listId
                    ,listname:this.state.listName
                    ,listdescription:this.state.listDescription || '&nbsp;'
                    ,listarguments:this.state.fetchArguments
                    ,isactive:this.state.isActive
                    ,cur_userid:this.props.loginData.Id
                    ,cur_username:this.props.loginData.Name
                })
            })
            .then(response => response.json())
            .then(result => {
                this.setState({ 
                    listId: result.data !== "" && result.data.length ? result.data[0] : "New", 
                    loading: false 
                });
                this.props.updateSegmentationsList(result);
                this.handleRefreshResults();
            });
        }
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar esta lista?")){
            this.setState({loading:true});
            fetch(API + 'deletesegmentation&listid=' + this.state.listId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false });
            });
        }
    }

    addArgument = () =>{
        const fetchArguments = [...this.state.fetchArguments];
        const index = Math.max(1, ...fetchArguments.map(x => x.index+1));
        fetchArguments.push({
            index: index,
            groupId: 0,
            text: '',
            field: {
                id: `field_${index}`,
                value: '',
                type: ''
            },
            condition: {
                id: `condition_${index}`,
                value: '',
                type: ''
            },
            finalArgument: ''
        });

        this.setState({ fetchArguments });
    }

    updateArgument = (argument = {}, text) => {
        const fetchArguments = [...this.state.fetchArguments];
        const thisArgument = fetchArguments.find(x => x.index === argument.index);

        thisArgument.field = argument.field;
        thisArgument.condition = argument.condition;
        thisArgument.finalArgument = argument.finalArgument;
        thisArgument.text = text;

        this.setState({ fetchArguments }, this.updateFilterText);
    }

    updateFilterText = () => {
        const { groups, fetchArguments } = this.state;
        const newFetchArguments = [...fetchArguments];
        let filterText = '';

        for(let i=0, n=newFetchArguments.length;i<n;i++){
            const thisArgument = newFetchArguments[i];
            const thisGroup = groups.find(x => x.id === thisArgument.groupId);
            const thisIndexInGroup = thisGroup && thisGroup.indexesInGroup.indexOf(thisArgument.index);
            let operator = i === 0 || (i === 0 && thisIndexInGroup > 0) ? '(' : ' OU (';
            if(thisArgument.text){
                operator = thisArgument.groupId !== 0 && thisIndexInGroup !== 0 ? ' E ' : operator;
                const closeBrackets = (thisGroup && Math.max(...thisGroup.indexesInGroup) === thisArgument.index) || thisArgument.groupId === 0 ? ')' : '';
                filterText += `${operator}${thisArgument.text}${closeBrackets}`;
            }
        }

        this.setState({ filterText });
    }

    handleRefreshResults = () => {
        this.setState({loading: true});
        fetch(API + "getsegmentationlistclients&listid=" + this.state.listId)
        .then(response => response.json())
        .then(result => {
            this.setState({
                loading: false, 
                segmentationResults: result.data,
                listResults: result.data.length
            });
        });
    }

    handleGroupChange = (e, item) => {
        const thisGroupId = parseInt(e.target.name.substring(e.target.name.indexOf('_') +1));
        const fetchArguments = [...this.state.fetchArguments];
        
        let groups = [...this.state.groups];
        let value = e.target.value;

        if(item.props.value==="DEFAULT"){
            value = "";
        }else{
            if (value.length > 1 && value.indexOf("DEFAULT") > -1){
                value.splice(value.indexOf("DEFAULT"), 1);
            }

            if(!value.length)
                value = "";
        }

        if(value){
            value.sort();
            groups.find(x => x.id === thisGroupId).indexesInGroup = value;
        }else{
            groups = groups.filter(x => x.id !== thisGroupId);
        }

        for(let i=0,n=fetchArguments.length;i<n;i++){
            const thisArg = fetchArguments[i];
            const group = groups.find(x => x.indexesInGroup.includes(thisArg.index));
            thisArg.groupId = group ? group.id : 0;
        }

        fetchArguments.sort((a, b) => a.index - b.index).sort((a, b) => a.groupId - b.groupId);

        this.setState({ groups, fetchArguments }, this.updateFilterText);
    }

    handleCreateNewGroup = () => {
        if(this.state.fetchArguments.length){
            const groups = [...this.state.groups];
            groups.push({
                id: Math.max(1, ...groups.map(x => x.id+1)),
                indexesInGroup: ["DEFAULT"]
            });
            this.setState({ groups });
        }
    }

    handleDeleteArgument = (index) => {
        const { groups, fetchArguments, filterText } = this.state;
        let textToRemove = '';
        // const filterText = this.state.filterText.replace(this.state.fetchArguments.find(a => a.index === index).text, '');

        const thisArgument = fetchArguments.find(a => a.index === index)
        const thisIndex = fetchArguments.findIndex(a => a.index === index);
        const thisGroup = groups.find(x => x.id === thisArgument.groupId);
        const thisIndexInGroup = thisGroup && thisGroup.indexesInGroup.indexOf(index);

        if(thisArgument.text){
            let operator = thisIndex === 0 || (thisIndex === 0 && thisIndexInGroup === 0) ? '(' : ' OU (';
            operator = thisArgument.groupId !== 0 && thisIndexInGroup !== 0 ? ' E ' : operator;
            const closeBrackets = (thisGroup && Math.max(...thisGroup.indexesInGroup) === thisArgument.index) || thisArgument.groupId === 0 ? ')' : '';
            textToRemove = `${operator}${thisArgument.text}${closeBrackets}`;
        }

        this.setState({fetchArguments: fetchArguments.filter(a => a.index !== index), filterText: filterText.replace(textToRemove, '')});
    }

    renderGroupOptions = (thisId) => {
        const { fetchArguments, groups } = this.state;

        const items = [<option value="DEFAULT" key="0">Nenhum</option>];
        for (let i=0;i<fetchArguments.length;i++) {
            const thisIndex = fetchArguments[i].index;
            if(!groups.find(x => x.indexesInGroup.includes(thisIndex)) || groups.find(x => x.id === thisId).indexesInGroup.includes(thisIndex)){
                items.push(<option 
                            checked={!groups.find(x => x.indexesInGroup.includes(thisIndex))}
                            key={thisIndex} 
                            value={thisIndex}>{thisIndex}</option>);
            }
        }
        return items;
    }

    renderSegmentationResults = () => {
        const segmentationResults = this.state.segmentationResults;
        const elements = [];

        for(let i=0,n=segmentationResults.length;i<n;i++){
            const thisResult = segmentationResults[i];
            elements.push(<p key={`${i}_${thisResult.Id}`}>Nome: {thisResult.ClientFirstName} {thisResult.ClientLastName} - Telefone: {thisResult.ClientPhoneNumber} - Email: {thisResult.ClientEmail}</p>);
        }

        return elements;
    }

    render() {
        const { isAdmin, loginData, } = this.props;
        const { editable, listName, fetchArguments, groups } = this.state;
        const loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div id="addEditSegmentationPage" className={"addEditPage" + loadingClass}>
                <div ref="editForm" className="form">
                    <div className="row">
                        <div className="col-12">
                            <h1><i className="fa fa-address-book"></i> {listName}
                                { (isAdmin || loginData.profile.Segmentation.isActive) && 
                                    <span className="float-right">
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="isActive"
                                                    checked={!!+this.state.isActive}
                                                    disabled={!(isAdmin || (loginData.profile.Segmentation.isActive.permission === 1 && editable))}
                                                    onChange={this.handleToggle}
                                                    color="primary"/>
                                            }
                                            label="Ativo"/>
                                    </span>
                                }
                            </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-8">
                            <div className="fieldHolder">
                                <TextField fullWidth
                                           id="listName"
                                           value={this.state.listName}
                                           onChange={this.handleFieldChange}
                                           label="Nome da lista"
                                           placeholder="Introduza o Nome da Lista"
                                           disabled={!editable} />
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="fieldHolder">
                                <TextField fullWidth
                                        id="listResults"
                                        value={this.state.listResults}
                                        label="Resultados"
                                        disabled={true} />
                            </div>
                            <Tooltip
                                title={this.renderSegmentationResults()}
                                enterDelay={200}>
                                <span className="float-right">
                                    <button 
                                        type="button" 
                                        // onClick={this.handleRefreshResults} 
                                        className="actionButton resultsPeek successColor">
                                            <i className="fas fa-eye"></i>
                                    </button>
                                </span>
                            </Tooltip>
                        </div>
                        <div className="col-12">
                            <p>Filtro: Todos os clientes com {this.state.filterText}</p>
                        </div>
                        <div className="col-12 fieldHolder">
                            <h4>
                                <Button onClick={this.handleCreateNewGroup} variant="contained" color="primary" disabled={fetchArguments.length < 2}>Novo Grupo</Button>
                                {
                                    groups.map(group =>
                                        <FormControl key={group.id} className="groupSelectHolder">
                                            <InputLabel htmlFor={`group_${group.id}`}>Grupo {group.id}</InputLabel>
                                            <Select id={`group_${group.id}`}
                                                    name={`group_${group.id}`}
                                                    value={group.indexesInGroup}
                                                    onChange={this.handleGroupChange}
                                                    multiple>
                                                {this.renderGroupOptions(group.id)}
                                            </Select>
                                        </FormControl>
                                    )
                                }
                                <Tooltip
                                    title={"Adicionar Argumento"}
                                    enterDelay={200}>
                                    <span className="float-right">
                                        <button onClick={this.addArgument} type="button" className="actionButton success">Adicionar Argumento <i className="fa fa-plus"></i></button>
                                    </span>
                                </Tooltip>
                            </h4>
                        </div>
                    </div>
                    {
                        fetchArguments.map(argument =>
                            <SegmentationArgument 
                                key={argument.index} 
                                fields={this.state.fetchFields}
                                conditions={this.state.fetchConditions}
                                argument={argument} 
                                handleDeleteArgument={this.handleDeleteArgument}
                                updateArgument={this.updateArgument} 
                            />
                        )
                    }
                    
                    <div className="row">
                        <div className="col-12 buttonsHolder">
                            <Button onClick={this.props.closeModal} variant="contained" className="defaultButton">Fechar</Button>
                            { (isAdmin || loginData.profile.Segmentation.DEL) && this.state.listId !== "New" && <Button onClick={this.handleDelete} className="button button-danger" variant="contained">Apagar Lista</Button>}
                            { editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddEditSegmentation;
